/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { Expression } from "abreact/expression/Expression";
import { InlinePanelLayout } from "abreact/expression/layout/InlinePanelLayout";
import { ArgumentOperandValueEditorGroup } from "abreact/expression/ui/editor/impl/condition/operandValue/operand/argument/ArgumentOperandValueEditorGroup";
import { GuidedExpressionEditorUtils } from "abreact/expression/ui/editor/impl/utils/GuidedExpressionEditorUtils";
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbImage } from "abreact/misc/AbImage";
import { AbDialog } from "abreact/popup/AbDialog";
import { AbHBox } from "absdk/commons/ui/layout/AbHBox";
import { AbVSeparator } from "absdk/commons/ui/layout/AbVSeparator";
import { AbButton, AbButtonType } from "absdk/commons/ui/misc/AbButton";
import { Assert } from "abweb/utils/Assert";
import * as React from "react";
// import OperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperandValue;
// import OperatorOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperatorOperandValue;

export class AdvancedArgumentOperandValueEditorGroupButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogShown: "none"
    };
    this.showAdvancedArgumentOperandValueViewsInDialog = this.showAdvancedArgumentOperandValueViewsInDialog.bind(this);
  }
  render() {
    const tooltip = this.getTooltipSummary();
    if (this.props.isReadonly) {
      if (tooltip != null) {
        return /*#__PURE__*/React.createElement(AbImage, {
          className: "expression-editor-advanced-option-summary-readonly-image",
          image: "absdk:options",
          tooltip: tooltip
        });
      }
    } else if (this.props.advancedArgumentOperands.length > 0) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderAdvancedArgumentOperandValueViewsInDialog(), /*#__PURE__*/React.createElement(AbButton, {
        className: "expression-editor-advanced-option-button",
        dataTestId: `${this.props.dataTestId}-advanced-option-button`,
        type: AbButtonType.DEFAULT,
        tooltip: tooltip,
        icon: "absdk:options",
        onClick: this.showAdvancedArgumentOperandValueViewsInDialog
      }));
    }
    return null;
  }
  getTooltipSummary() {
    const summaryElements = [];
    for (const argumentOperand of this.props.advancedArgumentOperands) {
      const operandValue = GuidedExpressionEditorUtils.getArgumentOperandValue(this.props.operandValuesByOperandName, argumentOperand, true);
      if (operandValue != null) {
        if (summaryElements.length > 0) {
          summaryElements.push(/*#__PURE__*/React.createElement(AbVSeparator, null));
        }
        const summaryGenerator = this.props.componentFactory.getOperandValueSummaryGenerator();
        const advancedSummary = summaryGenerator.createRichSummary(operandValue, Expression.Domain.Constants.FUNCTION_SUMMARY_STANDARD, this.props.expressionDomainModel, this.props.operatorOperandValue.expOperator.id);
        summaryElements.push(advancedSummary);
      }
    }
    if (summaryElements.length > 0) {
      let className = "expression-editor-advanced-option-summary";
      if (this.props.isReadonly) {
        className += "-readonly";
      }
      return /*#__PURE__*/React.createElement(AbHBox, {
        className: className,
        spacing: true
      }, summaryElements);
    } else {
      return null;
    }
  }
  showAdvancedArgumentOperandValueViewsInDialog(event) {
    Assert.assert(!this.props.isReadonly);
    if (event.altKey && event.ctrlKey && event.shiftKey) {
      this.setState({
        dialogShown: "summary"
      });
    } else {
      this.setState({
        dialogShown: "full"
      });
    }
  }
  renderAdvancedArgumentOperandValueViewsInDialog() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.state.dialogShown === "summary" && /*#__PURE__*/React.createElement(AbDialog, {
      dataTestId: 'expression-editor-advanced-option-tooltip',
      title: "Advanced Options Summary",
      cancelButton: true,
      onClose: () => this.setState({
        dialogShown: "none"
      })
    }, this.getTooltipSummary()), this.state.dialogShown === "full" && /*#__PURE__*/React.createElement(AbDialog, {
      dataTestId: 'expression-editor-advanced-option-dialog',
      title: AbReactResources.expression_advanced_options(),
      cancelButton: true,
      onClose: () => this.setState({
        dialogShown: "none"
      })
    }, this.props.advancedArgumentOperands.length > 0 && !this.props.isReadonly && /*#__PURE__*/React.createElement(InlinePanelLayout.Container, {
      className: "expression-editor-advanced-option-input-box"
    }, /*#__PURE__*/React.createElement(ArgumentOperandValueEditorGroup, {
      customizationFunctions: this.props.customizationFunctions,
      isReadonly: false,
      sourceOperandValue: this.props.sourceOperandValue,
      operatorOperandValue: this.props.operatorOperandValue,
      operandValuesByOperandName: this.props.operandValuesByOperandName,
      argumentOperands: this.props.advancedArgumentOperands,
      liveViewSliceModel: this.props.liveViewSliceModel,
      isAdvanced: true,
      expressionDomainModel: this.props.expressionDomainModel,
      componentFactory: this.props.componentFactory,
      expTemplateConfiguration: this.props.expTemplateConfiguration,
      dataTestId: this.props.dataTestId,
      generateId: this.props.generateId,
      applyOperandValue: this.props.applyOperandValue
    }))));
  }
}
//# sourceMappingURL=AdvancedArgumentOperandValueEditorGroupButton.js.map
